import { render, staticRenderFns } from "./WebFormSubmitted.vue?vue&type=template&id=56e31be8&scoped=true"
import script from "./WebFormSubmitted.vue?vue&type=script&lang=js"
export * from "./WebFormSubmitted.vue?vue&type=script&lang=js"
import style0 from "./WebFormSubmitted.vue?vue&type=style&index=0&id=56e31be8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e31be8",
  null
  
)

export default component.exports